import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UriService {
  constructor() {}

  public getQueryParamsObjectFromUrl(url: string): object {
    const queryString = this.getQueryStringFromUrl(url);

    return this.convertQuerysringToObject(queryString);
  }

  public convertQuerysringToObject(queryString: string): object {
    const queryObject = {};
    if (!queryString) {
      return queryObject;
    }

    const parts = queryString.split('&');
    parts.forEach((value) => {
      const pair = value.split('=');
      queryObject[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    });

    return queryObject;
  }

  public getQueryStringFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    const indexOfQ = url.indexOf('?');
    if (indexOfQ >= 0) {
      return url.substring(indexOfQ + 1);
    } else {
      return '';
    }
  }

  public appendParameterToUrl(url: string, key: string, value: string): string {
    if (!url || !key) {
      return url;
    }

    if (url.indexOf('?') === -1) {
      url += '?';
    } else {
      url += '&';
    }

    url += `${key}=${encodeURIComponent(value)}`;

    return url;
  }
}
